import request from "@/CommonDP/utils/request";

export default {
  queryPrjChildTree(prjId) {
    return request.get(`/prjChild/tree?prjId=${prjId}`).then((res) => res);
  },
  queryPrjChildList(childId, prjId) {
    return request
      .get(`/prjChild/list?childId=${childId}&prjId=${prjId}`)
      .then((res) => res);
  },
  queryQgPrjChildList(childId, prjId, specId) {
    return request
      .get(`/prjChild/list?childId=${childId}&prjId=${prjId}&specId=${specId}`)
      .then((res) => res);
  },

  delPrjChild(data) {
    return request.post(`/prjChild/delete`, data).then((res) => res);
  },
  querySpecUserList(enterpriseId, prjId) {
    return request
      .get(
        `/prj-person-plan/spec-user-list?enterpriseId=${enterpriseId}&prjId=${prjId}`
      )
      .then((res) => res);
  },
  queryQgSpecUserList(enterpriseId, prjId, specId) {
    return request
      .get(
        `/prj-person-plan/spec-user-list?enterpriseId=${enterpriseId}&prjId=${prjId}&specId=${specId}`
      )
      .then((res) => res);
  },
  prjChildAdd(data) {
    return request.post(`/prjChild/add`, data).then((res) => res);
  }
};
